import { CSSProperties, ReactNode } from 'react';
import { formatNumberAsInt } from '@blisspointmedia/bpm-types/dist/formatUtils';

export interface TooltipItems {
  beforeTooltipText: string;
  tooltipText: string;
  color?: string;
}

export interface ActiveTooltip {
  item: DataItem;
  style: CSSProperties;
}

export const BAR_CATEGORY_GAP = 6;
export const DEFAULT_BAR_CHART_CONTAINER_HEIGHT = 57;
export const TOOLTIP_MARGINS = { left: 0, right: 50 };

export const SNAPSHOT_SORT_OPTIONS = [
  { value: 'Alphabetical' },
  { value: 'Highest to lowest' },
  { value: 'Lowest to highest' }
];

export const DEFAULT_FORMATTER = (value: number): string => formatNumberAsInt(value);

export interface DataItem {
  label: string | { top: string; bottom: string };
  label2?: string | { top: string; bottom: string };
  name: string;
  value: number;
  value2?: number;
  waterfallValue?: number;
  errorX?: [number, number];
  computedValue?: (value: number, value2?: number) => string;
  incrementality?: boolean;
  added?: boolean;
  icon?: ReactNode;
}

export interface SecondaryAxisConfig {
  values: Record<string, number | null>;
  formatter: (value: number) => string;
  color: string;
}
